//@ts-ignore
var Modal = require('../lib/Modal.js');

const VideoLightbox = () => {
  const modalLinks = document.querySelectorAll('.videoModal');
  if (!modalLinks) {
    return;
  }

  const modal = new Modal('video', {
    iframe: true,
    fullscreen: true,
    maxWidth: '90%',
    maxHeight: '90%'
  });

  modalLinks.forEach(element => {
    element.addEventListener('click', (event) => {
      event.preventDefault();
      modal.open({ href: element.getAttribute('href') });
    });
  });
};

export default VideoLightbox;